<template>
  <div class="cf-page-container">
    <div
      v-if="isLoading"
      :class="['cf-container-full-width', { 'cf-page-loader': isLoading }]"
    >
      <div class="cf-loader" />
    </div>

    <div
      v-else
      class="cf-card cf-card--mobile cf-flex cf-flex--column cf-flex--gap-20"
    >
      <div class="cf-flex cf-flex--column cf-flex--gap-16">
        <div class="cf-flex cf-flex--row">
          <h1 class="cf-title cf-title--1">
            {{ content.Loyalty.title }}
          </h1>
        </div>

        <loyalty-summary />
      </div>

      <loyalty-offer-allocations-and-conversion-thresholds v-if="isEnrolledInLoyalty" />
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import LoyaltySummary from './loyalty-summary/index.vue';
  import LoyaltyOfferAllocationsAndConversionThresholds from './loyalty-offer-allocations-and-conversion-thresholds/index.vue';


  export default {
    name: 'OrderLoyaltyPage',

    metaInfo() {
      return {
        title: 'Loyalty'
      };
    },

    components: {
      LoyaltySummary,
      LoyaltyOfferAllocationsAndConversionThresholds
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('offers', ['loyalty', 'offers']),
      ...mapGetters('session', ['currentUser', 'session']),
      ...mapGetters('merchant', ['merchant']),

      isLoading() {
        return this.offers.areLoading || this.currentUser.isRefreshing;
      },

      isEnrolledInLoyalty() {
        return this.loyalty.isEnrolled;
      },

      displayRewardsActivityLink() {
        const { memberActivityUIEnabled } = this.merchant.options.loyaltyOptions;

        return memberActivityUIEnabled && this.merchant.features['loyalty-activity-tab-enabled'];
      }
    },

    created() {
      this.onComponentCreated();
    },

    methods: {
      async onComponentCreated() {
        if (!this.session.initialPageLoad) {
          await this.$store.dispatch('offers/getOffers');
          await this.$store.dispatch('session/refreshProfile');
        }

        this.conditionallyOpenInStoreRedemptionModal();

        this.$store.dispatch('merchant/openInAppMessage', { type: 'Loyalty' });
      },

      conditionallyOpenInStoreRedemptionModal() {
        const id = this.$route.query.redeemInStoreId;

        if (!id) {
          return;
        }

        const matchingOffer = this.offers.allOffers.find(offer => offer.offerAllocationPublicId === id);

        this.$openModal('offerInStoreRedemption', { offer: matchingOffer });
      }
    }
  };
</script>
